import VueI18n from 'vue-i18n';
import { getCurrentInstance } from '@vue/composition-api';
import DEFAULT_TRANSLATIONS from '@/i18n/locales/en.json';

export function useI18n() {
  const vm = getCurrentInstance()!;

  return {
    initializeI18n() {
      const i18n = vm.proxy.$root.$i18n;
      vm.proxy.$root.$i18n.mergeLocaleMessage(i18n.locale, DEFAULT_TRANSLATIONS);
    },

    async changeLanguage(language: string) {
      const i18n = vm.proxy.$root.$i18n;

      try {
        const translations: VueI18n.LocaleMessageObject =
          await import(`../i18n/locales/${language}.json`);

        i18n.mergeLocaleMessage(language, translations);
        i18n.locale = language;
      } catch (e) {
        console.debug('Failed to download translations!', e);
      }
    },
  };
}
